import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectResultDto } from '../models/ObjectResult';
import { HttpClient } from '@angular/common/http';
import { EntryPoints } from '../entrypoints';
import { sprintf } from 'sprintf-js';
import { NotifcationDto } from '../models/notification';
import * as signalR from '@aspnet/signalr';
import { AuthenticationService } from './auth.service';
import { MessagesService } from './messages.service';
import { InternalMessage } from '../models/internal.message';
import Actions from '../constants/actions';

@Injectable({
    providedIn: 'root'
})
export class NotifcationService extends EntryPoints {
    private hubConnection: signalR.HubConnection;
    

    constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService, private messagesService: MessagesService) {
        super();
    }

    getnotifcationbyId(id: number): Observable<ObjectResultDto> {
        return this.httpClient.get<ObjectResultDto>(sprintf(this.getnotifcationbyId, id));
    }
    updatenotifcation(id: number): Observable<ObjectResultDto> {
       
        return this.httpClient.delete<ObjectResultDto>(sprintf(this.setreadNotificationUrl, id));
        
    }   
    getAllnotifcation(): Observable<ObjectResultDto> {
        return this.httpClient.get<ObjectResultDto>(this.getallNotificationUrl);
    }  
       
    
}

